import * as React from 'react';
import { useSelector } from 'react-redux';

import { ReviewsCount } from '../../components/Header/parts/ReviewsCount';
import { getObjectInfo } from '../../selectors/objectInfo';

export const ReviewsCountContainer: React.FC = () => {
  const { reviewsCount, objectName, objectUrl, rating } = useSelector(getObjectInfo);

  return (
    <ReviewsCount
      reviewsCount={reviewsCount}
      newbuildingName={objectName}
      newbuildingLink={objectUrl}
      newbuildingRatings={rating}
    />
  );
};
